(function () {
  document.querySelectorAll('[data-dp-slider]').forEach(function (slider) {
    var wrap = slider.closest('.dp-slider-wrap');
    var prevBtn = wrap.querySelector('[data-dp-slider-prev]');
    var nextBtn = wrap.querySelector('[data-dp-slider-next]');

    function itemWidth() {
      var item = slider.querySelector('.dp-product-slider__item');
      return item ? item.getBoundingClientRect().width + 20 : 300;
    }

    function scrollByAmount(dir) {
      slider.scrollBy({ left: dir * itemWidth(), behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByAmount(-1); stopAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByAmount(1); stopAutoplay(); });

    // Autoplay: avanza sola cada 4 segundos, vuelve al principio al llegar al final
    var autoplayTimer = null;

    function startAutoplay() {
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        var maxScroll = slider.scrollWidth - slider.clientWidth;
        if (slider.scrollLeft >= maxScroll - 5) {
          slider.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollByAmount(1);
        }
      }, 4000);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        // se reanuda sola a los 6s de inactividad tras un clic manual
        setTimeout(startAutoplay, 6000);
      }
    }

    // pausar mientras el ratón está encima o mientras el usuario toca/arrastra
    slider.addEventListener('mouseenter', function () { clearInterval(autoplayTimer); });
    slider.addEventListener('mouseleave', startAutoplay);
    slider.addEventListener('touchstart', function () { clearInterval(autoplayTimer); }, { passive: true });

    startAutoplay();
  });
})();